function feather(angleDeg: number, length: number, width: number) {
  const rad = (angleDeg * Math.PI) / 180;
  const rootX = 158;
  const rootY = 108;
  const tipX = rootX - Math.cos(rad) * length;
  const tipY = rootY + Math.sin(rad) * length;
  const nx = Math.sin(rad);
  const ny = Math.cos(rad);
  const midX = rootX - Math.cos(rad) * length * 0.58;
  const midY = rootY + Math.sin(rad) * length * 0.58;
  const n = (value: number) => value.toFixed(1);
  return [
    `M ${n(rootX)} ${n(rootY)}`,
    `C ${n(midX + nx * width)} ${n(midY + ny * width)}, ${n(tipX + nx * width * 0.22)} ${n(tipY + ny * width * 0.22)}, ${n(tipX)} ${n(tipY)}`,
    `C ${n(tipX - nx * width * 0.22)} ${n(tipY - ny * width * 0.22)}, ${n(midX - nx * width)} ${n(midY - ny * width)}, ${n(rootX + 3)} ${n(rootY + 6)}`,
    'Z',
  ].join(' ');
}

const PRIMARIES = [
  feather(-46, 72, 14),
  feather(-28, 104, 16),
  feather(-10, 122, 17),
  feather(8, 114, 16),
  feather(26, 90, 15),
];

const SECONDARIES = [
  feather(-34, 64, 13),
  feather(-14, 78, 13),
  feather(4, 72, 12),
  feather(20, 58, 12),
];

const COVERTS = [feather(-18, 40, 11), feather(0, 46, 11), feather(16, 38, 10)];

function Feathers({ paths, opacity }: { paths: string[]; opacity: number }) {
  return paths.map((d) => <path key={d} d={d} opacity={opacity} />);
}

export function DivineWings({ idPrefix }: { idPrefix: string }) {
  const grad = `${idPrefix}-wing`;
  return (
    <>
      <span className="fx__wing-slot fx__wing-slot--left">
        <Wing grad={grad} define />
      </span>
      <span className="fx__wing-slot fx__wing-slot--right">
        <Wing grad={grad} />
      </span>
    </>
  );
}

function Wing({ grad, define = false }: { grad: string; define?: boolean }) {
  return (
    <svg className="fx__wing" viewBox="0 0 180 210" aria-hidden="true">
      {define && (
        <defs>
          <linearGradient id={grad} x1="0" y1="0" x2="1" y2="0.4">
            <stop offset="0%" stopColor="#ffffff" />
            <stop offset="48%" stopColor="#f7edd8" />
            <stop offset="100%" stopColor="#d7a441" />
          </linearGradient>
        </defs>
      )}
      <g className="fx__feather-row fx__feather-row--3" fill={`url(#${grad})`}>
        <Feathers paths={PRIMARIES} opacity={0.92} />
      </g>
      <g className="fx__feather-row fx__feather-row--2" fill={`url(#${grad})`}>
        <Feathers paths={SECONDARIES} opacity={0.78} />
      </g>
      <g className="fx__feather-row fx__feather-row--1" fill={`url(#${grad})`}>
        <Feathers paths={COVERTS} opacity={0.66} />
      </g>
      <ellipse cx="156" cy="112" rx="16" ry="22" fill={`url(#${grad})`} />
    </svg>
  );
}
